<template>
    <div class="modal fade" id="login-modal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="بستن"></button>
                </div>
                <div class="modal-body">
                    <div class="tab-content">
                        <div class="tab-pane fade show active text-end">
                            <div class="mb-3">
                                <p class="text-center">
                                <lord-icon
                                    src="/img/icons/sdiulnbs.json"
                                    trigger="loop"
                                    delay="2000">
                                </lord-icon>
                                </p>
                                <div class="form-floating mb-3" dir="rtl">
                                  <input type="text" id="phoneNumFloat" placeholder="شماره موبایل" inputmode="numeric" v-model="phone" v-if="!checkCodeLogin" class="form-control">
                                  <input type="text" id="codeinput" autocomplete="one-time-code" inputmode="numeric" placeholder="کد" v-model="code" v-if="checkCodeLogin" class="form-control">
                                  <label for="phoneNumFloat" v-if="!checkCodeLogin"> شماره موبایل </label>
                                  <label for="codeinput" v-if="checkCodeLogin"> کد یکبار مصرف </label>
                                  <div id="nameHelp" v-if="!checkCodeLogin" class="form-text mb-3 mt-2">شماره موبایل برای ارسال کد یکبار مصرف</div>
                                  <div class="form-text mb-3 mt-2" v-if="checkCodeLogin && !retry"> {{ time }} مانده تا دریافت کد مجدد</div>
                                  <button aria-label="ارسال شماره موبایل" @click="loginRequest()" v-if="!checkCodeLogin" class="btn btn-secondary" :disabled="loader">ادامه</button>
                                  <div class="form-text mb-3 mt-2" v-if="retry"> شماره خود را به درستی وارد کردید؟ {{ phone }} </div>
                                  <button aria-label="ارسال مجدد کد" @click="loginRequest()" v-if="retry" class="btn btn-secondary" :disabled="loader">ارسال مجدد</button>
                                  <button aria-label="اصلاح شماره تماس" @click="checkCodeLogin = false;retry = false; code = ''; phone = ''" v-if="retry" class="btn btn-secondary mx-2" :disabled="loader">اصلاح شماره تماس</button>
                                  <button aria-label="ارسال کد" @click="checkLoginCode()" v-if="checkCodeLogin && !retry" class="btn btn-secondary" :disabled="loader">ادامه</button>
                                  <p class="m-3 text-muted">با ثبت نام در نوراشاپ شرایط استفاده از <router-link class="text-info" to="/terms">خدمات و حریم خصوصی </router-link>را می‌پذیرم.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
  name: 'LoginModal',
  data () {
    return {
      loader: false,
      checkCodeLogin: false,
      timer: null,
      duration: 120,
      time: 120,
      retry: false,
      phone: '',
      name: '',
      code: '',
      ac: null
    }
  },
  watch: {
    code (to, from) {
      if (to.toString().length === 4) {
        this.checkLoginCode()
      }
    },
    phone (to, from) {
      if (to.length === 11) {
        this.loginRequest()
      }
    }
  },
  methods: {
    startTimer () {
      this.retry = false
      let timer = this.duration
      this.timer = setInterval(() => {
        this.time = timer
        if (--timer < 1) {
          timer = 0
          clearInterval(this.timer)
          this.retry = true
        }
      }, 1000)
    },
    stopTimer () {
      clearInterval(this.timer)
    },
    loginRequest: function () {
      this.loader = true
      const mutation = `
        mutation sendCode {
          generatorCode(phone: "${this.phone}") {
            status
          }
        }
      `
      this.$fetchGraphQL(mutation).then(response => {
        if (response.data.generatorCode.status === 'success') {
          this.checkCodeLogin = true
          this.startTimer()
          this.loader = false
          if ('OTPCredential' in window) {
            this.ac = new AbortController()
            navigator.credentials.get({
              otp: { transport: ['sms'] },
              signal: this.ac.signal
            }).then(otp => {
              this.code = otp.code
            }).catch(err => {
              console.log(err)
            })
          }
        }
      })
    },
    checkLoginCode: function () {
      if (this.ac) {
        this.ac.abort()
      }
      this.loader = true
      const mutation = `
        mutation checkCode {
          checkCode(phone: "${this.phone}", code: "${this.code}") {
            status
            user {
              wallet
              username
              name: lastName
              address
              gender
              isStaff
            }
          }
        }
      `
      this.$fetchGraphQL(mutation).then(response => {
        if (response.data.checkCode.status === 'success') {
          localStorage.setItem('isAuthenticated', true)
          localStorage.setItem('User', JSON.stringify(response.data.checkCode.user))
          location.reload()
          this.loader = false
        } else if (response.data.checkCode.status === 'forbiddenTime') {
          this.fire({
            icon: 'error',
            title: 'زمان مصرف کد به اتمام رسیده است',
            showConfirmButton: false,
            timer: 2000
          })
          this.retry = true
          this.stopTimer()
          this.loader = false
        } else {
          this.fire({
            icon: 'error',
            title: 'کد وارد شده اشتباه است',
            showConfirmButton: false,
            timer: 2000
          })
          this.loader = false
        }
      })
    }
  }
}
</script>
<style scoped>
.spinner-grow{
    margin:60px;
}
.modal-content{
    min-width: 300px;
    max-width: 500px;
    direction: rtl;
    text-align: center;
    border: none;
    border-radius: 24px;
}
.modal-header .btn-close{
    margin: -.5rem auto -.5rem -.5rem;
}
.modal-header{
    border-bottom: none;
}

.modal-dialog {
    position: relative;
    width: auto;
    margin: 10vh auto;
    pointer-events: none;
    max-width: fit-content;
}
.form-floating>label{
  right: 0 !important;
  color: gray;
}
.form-floating > .form-control, .form-floating > .form-control-plaintext{
  border-radius: 16px;
}
</style>
